/**
 * Constantes centralisées pour l'application
 */

// URLs et routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  PROFILE: '/profile',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/projects/:slug',
  PROJECT_EDIT: '/projects/:slug/edit',
  PROJECT_SEO_DETAIL: '/projects/:slug/seo/:encodedUrl',
  DOCS: '/docs',
};

// Pages d'authentification
export const AUTH_PAGES = [
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.FORGOT_PASSWORD,
];

// Statuts de performance Lighthouse
export const PERFORMANCE_STATUS = {
  GOOD: 'good',
  NEEDS_IMPROVEMENT: 'needs-improvement',
  POOR: 'poor',
};

// Couleurs associées aux statuts
export const STATUS_COLORS = {
  [PERFORMANCE_STATUS.GOOD]: 'success',
  [PERFORMANCE_STATUS.NEEDS_IMPROVEMENT]: 'warning',
  [PERFORMANCE_STATUS.POOR]: 'error',
};

// Métriques Lighthouse
export const LIGHTHOUSE_METRICS = {
  PERFORMANCE: 'performance',
  ACCESSIBILITY: 'accessibility',
  BEST_PRACTICES: 'best-practices',
  SEO: 'seo',
};

// Types d'audit
export const AUDIT_TYPES = {
  SEO: 'seo',
  PERFORMANCE: 'performance',
  ACCESSIBILITY: 'accessibility',
  BEST_PRACTICES: 'best-practices',
};

// Statuts d'audit
export const AUDIT_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

// Types de projets
export const PROJECT_TYPES = {
  WEBSITE: 'website',
  ECOMMERCE: 'ecommerce',
  BLOG: 'blog',
  CORPORATE: 'corporate',
};

// Configuration des clés API
export const API_KEYS_CONFIG = {
  GOOGLE_PAGE_SPEED: 'google_page_speed',
  GEMINI: 'gemini',
};

// Messages d'erreur communs
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur réseau',
  UNAUTHORIZED: 'Non autorisé',
  FORBIDDEN: 'Accès refusé',
  NOT_FOUND: 'Ressource non trouvée',
  SERVER_ERROR: 'Erreur serveur',
  VALIDATION_ERROR: 'Erreur de validation',
  TOKEN_EXPIRED: 'Token expiré',
  SESSION_EXPIRED: 'Session expirée',
};

// Messages de succès communs
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Connexion réussie !',
  REGISTER_SUCCESS: 'Inscription réussie !',
  PROJECT_CREATED: 'Projet créé avec succès !',
  PROJECT_UPDATED: 'Projet mis à jour avec succès !',
  PROJECT_DELETED: 'Projet supprimé avec succès !',
  AUDIT_COMPLETED: 'Audit terminé avec succès !',
  DATA_SAVED: 'Données sauvegardées avec succès !',
};

// Configuration des toasts
export const TOAST_CONFIG = {
  DURATION: 5000,
  POSITION: 'top-right',
};

// Types de toast
export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

// Configuration des modales
export const MODAL_CONFIG = {
  BACKDROP_CLICKABLE: true,
  ESC_KEY_CLOSABLE: true,
};

// Limites et pagination
export const LIMITS = {
  PROJECTS_PER_PAGE: 10,
  AUDITS_PER_PAGE: 20,
  URLS_PER_BATCH: 5,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
};

// Formats de date
export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  API: 'YYYY-MM-DD',
  DATETIME: 'DD/MM/YYYY HH:mm',
  TIME: 'HH:mm',
};

// Regex patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  URL: /^https?:\/\/.+/,
  DOMAIN: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
  SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
};

// Configuration des icônes
export const ICON_SIZES = {
  SMALL: '16px',
  MEDIUM: '20px',
  LARGE: '24px',
  XLARGE: '32px',
};

// Configuration des couleurs du thème
export const THEME_COLORS = {
  PRIMARY: 'blue',
  SECONDARY: 'gray',
  SUCCESS: 'green',
  WARNING: 'yellow',
  ERROR: 'red',
  INFO: 'blue',
};

// Configuration des breakpoints responsive
export const BREAKPOINTS = {
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px',
};

// Configuration des animations
export const ANIMATIONS = {
  DURATION: {
    FAST: '150ms',
    NORMAL: '300ms',
    SLOW: '500ms',
  },
  EASING: {
    EASE_IN: 'ease-in',
    EASE_OUT: 'ease-out',
    EASE_IN_OUT: 'ease-in-out',
  },
};

// Configuration des débounce delays
export const DEBOUNCE_DELAYS = {
  SEARCH: 300,
  INPUT: 500,
  API_CALL: 1000,
};

// Configuration des retry
export const RETRY_CONFIG = {
  MAX_ATTEMPTS: 3,
  DELAY: 1000,
  BACKOFF_MULTIPLIER: 2,
};
